import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { PageSettingsModel, ToolbarItems, Column, IEditCell, SaveEventArgs, IEdit } from '@syncfusion/ej2-angular-grids';
import { AutoComplete, ChangeEventArgs, FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { EmitType, createElement } from '@syncfusion/ej2-base';
import { DataManager } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { AuthenService } from '../../services/authen.service';
import { UrlParams } from '../../helpers/url-params';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { saveAs as importedSaveAs } from "file-saver";
import { ClickEventArgs } from '@syncfusion/ej2-navigations';
import { Util } from '../../helpers/global.util';

@Component({
    selector: 'contract-all',
    templateUrl: './contract-all.html',
})
export class ContractAllComponent implements OnInit, OnDestroy {
    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    @ViewChild('gridContract') grid;    

    gridData: DataManager;
    toolbar: ToolbarItems[] | object;;        
    pageSettings: PageSettingsModel;
    dateFormat: string = 'dd/MM/yyyy';    
    formatNumericWith0: string = 'N';
    statusList = [];
    stateList = [];        
    dtFrom: Date = null;    
    state: string = null;
    status: string = null;
    statusStringSelected: Array<any> = [];
    province: string = null;
    custCode: string = null;
    custName: string = null;
    refNo: string = null;
    contractType: string = null;
    contractTypeStringSelected: Array<any> = [];
    HSCode: string = null;
    ContractTypeList: any[] = [];
    nameValueFields: Object = { text: 'Name', value: 'Value' };


    editSettings: Object;


    sendToSCDate: Date = null;    
    waiting: boolean = false;
    notAllowEditCol: boolean = false;
    
    get AppConst() { return AppConst; }

    constructor(private auth: AuthenService, private http: HttpService, private helper: HelperService, private notify: NotifyService, private elementRef: ElementRef) {
        this.pageSettings = { pageSize: 30 };
        this.toolbar = ['Edit', 'Update', 'Cancel'];//,{ text: 'Export', tooltipText: 'Export', id: 'Export' }];
        this.editSettings = { allowEditing: true };
    }

    ngOnDestroy() {
    }

    initParams() {        
        this.toolbar = ['Edit', 'Update', 'Cancel'];//, { text: 'Export', tooltipText: 'Export', id: 'Export' }];
        this.editSettings = { allowEditing: true };              
    }

   


    ngOnInit() {
        this.initParams();
        this.http.get('api/Util/GetStateList/', res => {
            this.stateList = res.Result;
        }, null);

        this.http.get('api/Util/GetContractStatusList', res => {
            this.statusList = res.Result;            
        });
        setTimeout(() => this.http.get('api/Util/GetContractTypeList', res => {
            //debugger;
            this.ContractTypeList = res.Result;            
        }), 100);                                                        
        
        this.onSearch();

        //setTimeout(() => {
        //    this.grid.toolbarModule.enableItems(['Export'], false);
        //}, 500);
    }

    onSearch() {

        this.status = Util.array2String(this.statusStringSelected);
        this.contractType = Util.array2String(this.contractTypeStringSelected);


        let params = new UrlParams();
        params.addDate('dtFrom', this.dtFrom);
        params.add('state', this.state, '');
        params.add('status', this.status, '');
        params.add('province', this.province, '');
        params.add('custName', this.custName, '');
        params.add('custCode', this.custCode, '');
        params.add('refNo', this.refNo, '');
        params.add('contractType', this.contractType, '');
        params.add('HSCode', this.HSCode, '');
        params.addDate('sendToSCDate', this.sendToSCDate);
        
        this.gridData = this.http.getByEditManager(`api/Contract/Search/${params.toString()}`, this.auth);
    }

    onExport() {

        this.status = Util.array2String(this.statusStringSelected);
        this.contractType = Util.array2String(this.contractTypeStringSelected);

        let ids = [];
        const selRows: object[] = this.grid.getSelectedRecords();  // Get the selected records.

        if (selRows != null) {
            selRows.forEach((p: any) => {
                ids.push(p.Id);
            });
            let params = new UrlParams();
            params.addDate('dtFrom', this.dtFrom);
            params.add('state', this.state);
            params.add('status', this.status, '');
            params.add('province', this.province, '');
            params.add('custName', this.custName, '');
            params.add('custCode', this.custCode, '');
            params.add('refNo', this.refNo, '');
            params.add('contractType', this.contractType, '');
            params.add('HSCode', this.HSCode, '');
            params.addDate('sendToSCDate', this.sendToSCDate);
            this.waiting = true;
            this.http.downloadSelections(`api/Contract/ExportContracts/${params.toString()}`, ids, res => {
                let fileNameExport = this.auth.LoginUser + '_ContractAll.xlsx';
                importedSaveAs(res, fileNameExport);
                this.waiting = false;
            });
        }
    }

    onImport() {        
        this.dlgImport.show('api/Contract/ImportContracts', null, res => {
            this.grid.refresh();            
        });
    }           

    onClearSearch() {
        this.dtFrom = null;
        this.state = null;
        this.status = null;
        this.statusStringSelected = [];
        this.province = '';
        this.custCode = '';
        this.custName = '';
        this.refNo = '';
        this.contractType = null;
        this.contractTypeStringSelected = [];
        this.HSCode = '';
        this.sendToSCDate = null;
        this.onSearch();
    }

    onExportAll() {
        this.status = Util.array2String(this.statusStringSelected);
        this.contractType = Util.array2String(this.contractTypeStringSelected);
        let ids = [];
        ids.push(0);
        let params = new UrlParams();
        params.addDate('dtFrom', this.dtFrom);
        params.add('state', this.state);
        params.add('status', this.status, '');
        params.add('province', this.province, '');
        params.add('custName', this.custName, '');
        params.add('custCode', this.custCode, '');
        params.add('refNo', this.refNo, '');
        params.add('contractType', this.contractType, '');
        params.add('HSCode', this.HSCode, '');
        params.addDate('sendToSCDate', this.sendToSCDate);
        this.waiting = true;
        this.http.downloadSelections(`api/Contract/ExportContracts/${params.toString()}`, ids, res => {
            let fileNameExport = this.auth.LoginUser + '_ContractAll.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });        
    }

    onExportDoc() {
        let ids = [];
        const selRows: object[] = this.grid.getSelectedRecords();  // Get the selected records.

        if (selRows != null) {
            this.waiting = true;
            selRows.forEach((p: any) => {
                ids.push(p.Id);
            });

            this.http.downloadSelections('api/Contract/CreateMultiContractDocs', ids, res => {
                let fileNameExport = 'ContractDocs.zip';
                importedSaveAs(res, fileNameExport);
                this.waiting = false;
            });
        }
    }

    onDownloadContract(id: number, contractNo: string, customerName: string) {        
        this.http.download('api/Contract/CreateContractDoc/' + id, res => {
            debugger;
            let fileNameExport = `ContractDoc_${customerName}.docx`;
            importedSaveAs(res, fileNameExport);
        });
    }

    onRowSelect(evt: any) {
      
    }
    onActionBegin: EmitType<SaveEventArgs> = (evt: any) => {
      
    }

}
